import {
  AmenitiesAwningAwningIcon,
  AmenitiesBookingBookerDeliveryOnlyIcon,
  Button,
  EButtonColorVariant,
  ETextStyleVariant,
  GeneralManageVehiclesOutlineIcon,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { EDeliveryOption } from '@/services/types/core/delivery.types';

type TDeliveryOptionTabsProps = {
  deliveryOption: EDeliveryOption;
  changeDeliveryOption: (option: EDeliveryOption) => void;
};
export const DeliveryOptionTabs = ({
  deliveryOption,
  changeDeliveryOption,
}: TDeliveryOptionTabsProps) => {
  const intl = useIntl();

  const dropdownOptions = [
    {
      label: intl.formatMessage({ defaultMessage: 'Pick it up', id: 'uCaDsz' }),
      Icon: GeneralManageVehiclesOutlineIcon,
      value: EDeliveryOption.PICKUP,
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Delivery', id: 'drqP2L' }),
      Icon: AmenitiesBookingBookerDeliveryOnlyIcon,
      value: EDeliveryOption.MOVING,
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Set up', id: 'rrGMSx' }),
      Icon: AmenitiesAwningAwningIcon,
      value: EDeliveryOption.STATIONARY,
    },
  ];
  return (
    <div className="flex mt-2 mb-8 gap-2">
      {dropdownOptions.map(({ value, label, Icon }) => (
        <Button
          className="py-2 px-2.5 sm:px-4"
          key={value}
          label={
            <span className="flex items-center justify-center gap-1 md:gap-2">
              <Icon width={20} height={20} />
              <Text variant={ETextStyleVariant.SmallBold}>{label}</Text>
            </span>
          }
          onClick={() => changeDeliveryOption(value)}
          variant={
            deliveryOption === value ? EButtonColorVariant.Tertiary : EButtonColorVariant.Secondary
          }
        />
      ))}
    </div>
  );
};
